import { SVGProps } from 'react';

export const GradientToolkitIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg data-icon xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none" {...props}>
      <path
        d="M5.45289 7.73684C5.45289 7.95485 5.62979 8.13158 5.84802 8.13158H7.11246C7.3307 8.13158 7.5076 7.95485 7.5076 7.73684V7.02632H13V10.8947C13 11.5052 12.5047 12 11.8936 12H1.10638C0.495343 12 2.22763e-08 11.5052 0 10.8947V7.02632H5.45289V7.73684ZM11.8936 3.67105C12.5047 3.67105 13 4.16589 13 4.77632V6H7.5076V5.28947C7.5076 5.07146 7.3307 4.89474 7.11246 4.89474H5.84802C5.62979 4.89474 5.45289 5.07146 5.45289 5.28947V6H0V4.77632C0 4.16589 0.495343 3.67105 1.10638 3.67105H11.8936ZM8.53495 0C9.14599 4.06903e-08 9.64134 0.494842 9.64134 1.10526V2.60526H8.61398V1.42105C8.61398 1.20305 8.43708 1.02632 8.21885 1.02632H4.74164C4.52341 1.02632 4.3465 1.20305 4.3465 1.42105V2.60526H3.31915V1.10526C3.31915 0.494842 3.81449 0 4.42553 0H8.53495Z"
        fill="url(#paint0_linear_4439_1274)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4439_1274"
          x1="12.1684"
          y1="10.0988"
          x2="7.01774"
          y2="-0.089161"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#12403A" />
          <stop offset="1" stopColor="#2FA696" />
        </linearGradient>
      </defs>
    </svg>
  );
};
